import React from 'react';
import {Route,Switch} from 'react-router-dom';
import GroupConfirmation from '../pages/PersonalAssistant/GroupConfirmation';
// Confirmation is public and must not restore a Cchat administrative session.
export default function AssistantPublicGate({children}){
 return <Switch><Route exact path={['/assistente/confirmar','/v']} component={GroupConfirmation}/><Route>{children}</Route></Switch>;
}
